import React from "react";
import { RyeBadge } from "../rye/RyeBadge";
import { RyeButton } from "../rye/RyeButton";
import { RyeVibe } from "../rye/RyeConsts";

export interface TransactionsScreenFilterBadgeProps {
  children: React.ReactNode;
  onRemove: () => void;
  vibe: RyeVibe;
}

export function TransactionsScreenFilterBadge({
  children,
  onRemove,
  vibe,
}: TransactionsScreenFilterBadgeProps): JSX.Element {
  return (
    <RyeBadge
      variant="outlined"
      vibe={vibe}
      shape="fully-round"
      size="sm"
      className="border-transparent border-0"
    >
      {children}
      <div className="-mr-2">
        <RyeButton
          onClick={onRemove}
          icon="close"
          size="sm"
          variant="transparent"
          vibe={vibe}
          shape="fully-round"
          tooltip="Remove filter"
        />
      </div>
    </RyeBadge>
  );
}
